import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-card__head modal-card__head_flex"
}
const _hoisted_2 = { class: "modal-card__head-icon" }
const _hoisted_3 = { class: "modal-card__titles" }
const _hoisted_4 = { class: "modal-card__title" }
const _hoisted_5 = { class: "modal-card__subtitle" }
const _hoisted_6 = { class: "modal-card__head-status-wrapper" }
const _hoisted_7 = {
  key: 1,
  class: "modal-card__head"
}
const _hoisted_8 = { class: "modal-card__title" }
const _hoisted_9 = { class: "modal-card__subtitle" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_11 = { class: "modal-card__body" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_13 = { class: "modal-card__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhoneIcon = _resolveComponent("PhoneIcon")!
  const _component_PcIcon = _resolveComponent("PcIcon")!
  const _component_TsdIcon = _resolveComponent("TsdIcon")!
  const _component_base_loader = _resolveComponent("base-loader")!

  return (_openBlock(), _createElementBlock("div", {
    class: "overlay",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideModal && _ctx.hideModal(...args)))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["modal-card", _ctx.classname])
    }, [
      (_ctx.showHeader)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.showRateDetails)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    (_ctx.rateType === _ctx.mobileType)
                      ? (_openBlock(), _createBlock(_component_PhoneIcon, {
                          key: 0,
                          large: ""
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.rateType === _ctx.desktopType)
                      ? (_openBlock(), _createBlock(_component_PcIcon, {
                          key: 1,
                          large: ""
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.rateType === _ctx.tsdType)
                      ? (_openBlock(), _createBlock(_component_TsdIcon, {
                          key: 2,
                          large: ""
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.title), 1),
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.subtitle), 1)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["modal-card__head-status", { 'modal-card__head-status_expired': !_ctx.isRateActive }])
                    }, _toDisplayString(_ctx.isRateActive ? "Активен" : "Истёк"), 3)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.title), 1),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.subtitle), 1)
                ])),
            _hoisted_10
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _renderSlot(_ctx.$slots, "body")
      ]),
      (_ctx.showFooter)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _renderSlot(_ctx.$slots, "footer")
            ])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_base_loader, {
            key: 2,
            type: "primary",
            size: "large",
            "modal-loader": true
          }))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}